import script from "./Div2.vue?vue&type=script&setup=true&lang=js"
export * from "./Div2.vue?vue&type=script&setup=true&lang=js"

import "./Div2.vue?vue&type=style&index=0&id=77ac1c63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77ac1c63"]])

export default __exports__